import React from 'react';
import ContentTemplate from 'templates/ContentTemplate';
// ROUTER
import { routes } from 'routes';
import { Link as RouterLink } from 'react-router-dom';
// REDUX
import { connect } from 'react-redux';
// BOUNDARY
import { ErrorBoundary } from 'react-error-boundary';
import ErrorAlert from 'boundary/ErrorAlert';
// COMPONENTS
import Heading from 'components/atoms/Heading/Heading';
import CardClassic from 'components/molecules/CardClassic/CardClassic';
import Link from 'components/atoms/Link/Link';

const Rankings = ({ cards, voivodeships }) => (
	<ContentTemplate>
		<>
			<Heading className="mb-4" featured>
				{`Tabele Rankingu ${process.env.REACT_APP_THEME === 'LICEA' ? 'Liceów' : 'Techników'} ${
					process.env.REACT_APP_EDITION
				}`}
			</Heading>

			{cards ? (
				<ErrorBoundary FallbackComponent={ErrorAlert}>
					<div className="row">
						{Object.entries(cards).map(([key, { title, featured, best }]) => (
							<div className="col-12 col-md-6" key={key}>
								<CardClassic
									title={title}
									link={`${routes.rankings}/${key}`}
									featuredTitle={featured}
									featured
									orderedList
									more
								>
									<ol>{best && best.map((bestSchool, index) => <li key={index}>{bestSchool}</li>)}</ol>
								</CardClassic>
							</div>
						))}

						<div className="col-12 col-md-6">
							<CardClassic title="Rankingi Wojewódzkie" unorderedList featured featuredTitle>
								<ul>
									{voivodeships.map(({ title, link }, index) => (
										<li key={index}>
											<Link as={RouterLink} to={link}>
												{title}
											</Link>
										</li>
									))}
								</ul>
							</CardClassic>
						</div>
					</div>
				</ErrorBoundary>
			) : (
				<ErrorAlert error={{ message: 'error' }} />
			)}
		</>
	</ContentTemplate>
);

const mapStateToProps = ({ initial, global }) => ({ cards: initial.winners, voivodeships: global.voivodeships });

export default connect(mapStateToProps)(Rankings);
